const state_ = () => ({
    items: [],
    pages: [],
    meta: [],
    current: false,
    currentId: false,
});


const getters_ = {
    pages(state) {
        return state.pages
    },
    meta(state) {
        return state.meta
    },
    items(state) {
        return state.items
    },
    currentId(state) {
        return state.currentId
    },
    current(state) {
        return state.current
    },
}

const actions_ = {
    async list({commit}, data) {
        let result = await this.$api.currencies.list(data)
        if (!result || typeof result.data == 'undefined') {
            return false
        }
        const answer = result.data;
        commit('setItems', answer)
        commit('setPages', result.links)
        commit('setMeta', result.meta)
        return answer
    },
};

const mutations_ = {
    setItems(state, items) {
        state.items = items;
    },
    setPages(state, data) {
        state.pages = data
    },
    setMeta(state, data) {
        state.meta = data
    },
};
export const actions = actions_;
export const state = state_;
export const mutations = mutations_;
export const getters = getters_;
